import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=375b7305&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"
import style0 from "./Album.vue?vue&type=style&index=0&id=375b7305&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b7305",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375b7305')) {
      api.createRecord('375b7305', component.options)
    } else {
      api.reload('375b7305', component.options)
    }
    module.hot.accept("./Album.vue?vue&type=template&id=375b7305&scoped=true", function () {
      api.rerender('375b7305', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/album/Album.vue"
export default component.exports